import { forwardRef, type Ref, type SVGProps } from "react";
const IconDirectionsOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M21.82 15.47a.7.7 0 0 0 0-.94l-3.66-4.19a1 1 0 0 0-1.4-.09 1 1 0 0 0-.08 1.41l2 2.34h-7.29A1.39 1.39 0 0 0 10 15.39V18a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-2h6.72l-2 2.34a1 1 0 0 0 .7 1.66 1 1 0 0 0 .74-.34Z" />
    <path d="m16 4 12 12-12 12L4 16zm0-2a2 2 0 0 0-1.4.58l-12 12a2 2 0 0 0 0 2.8l12 12a2 2 0 0 0 2.8 0l12-12a2 2 0 0 0 0-2.8l-12-12A2 2 0 0 0 16 2" />
  </svg>
);
const ForwardRef = forwardRef(IconDirectionsOutlineSVG);
ForwardRef.displayName = "IconDirectionsOutline";
export { ForwardRef as IconDirectionsOutline };
